/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import _ from "lodash";
import { SET_SELECTED_REALM, GET_REALMS, SET_FILTERED_REALMS, GET_SELECTED_REALM_DETAILS, RESET_REALMS, GET_REALM_ENTITLEMENTS, GET_ALL_IDPS, GET_BY_IDP_STATUS } from "./types";

const initialState: any = {
  realms: [],
  filteredRealms: [],
  idps: {},
  byIdpStatus: false,
  pagination: {
    pageNumber: 1,
    pageSize: 10,
    totalCount: 0,
  },
  selectedRealm: {},
  noRealm: false,
  selectedRealmDetails: {},
};

export const realmReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_REALMS:
      // const allRealmList = _.union([...state.realms, ...action.realms], 'id');
      return {
        ...state,
        realms: action.realms || [],
        selectedRealm: action.selectedRealm,
        pagination: action.pagination,
        noRealm: action.noRealm,
      };
    case SET_FILTERED_REALMS:
      return {
        ...state,
        filteredRealms: action.filteredRealms,
      };
    case SET_SELECTED_REALM:
      return {
        ...state,
        selectedRealm: {
          ...action.selectedRealm,
          entitlements: state.selectedRealm.entitlements,
        },
      };
    case GET_SELECTED_REALM_DETAILS:
      return {
        ...state,
        selectedRealmDetails: action.selectedRealmDetails,
      };
    case GET_REALM_ENTITLEMENTS:
      return {
        ...state,
        selectedRealm: {
          ...state.selectedRealm,
          entitlements: action.entitlements,
        },
      };
    case RESET_REALMS: {
      return {
        ...state,
        realms: [],
        noRealm: true,
        selectedRealm: {},
      };
    }
    case GET_ALL_IDPS:
      return {
        ...state,
        idps: action.idps,
      };
    case GET_BY_IDP_STATUS:
      return {
        ...state,
        byIdpStatus: action.byIdpStatus,
      };
    default:
      return state;
  }
};
